import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import { Phone } from '@mui/icons-material';
import { companyInfo } from '../data/products';

export default function CallFloat() {
  const makeCall = () => {
    window.location.href = `tel:${companyInfo.whatsapp}`;
  };

  return (
    <Tooltip title="Call us!" placement="left">
      <Fab
        color="primary"
        onClick={makeCall}
        sx={{
          position: 'fixed',
          bottom: 90,
          right: 20,
          '&:hover': {
            transform: 'scale(1.1)',
          },
          transition: 'all 0.3s ease',
          zIndex: 1000,
        }}
      >
        <Phone />
      </Fab>
    </Tooltip>
  );
}
